// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__eyMus","text":"Placeholder_text__HhH6I"};